<form [formGroup]="form">
  <beautyapp-textarea formControlName="disableReason" placeholder="გაუქმების მიზეზი" label="გაუქმების მიზეზი"></beautyapp-textarea>
</form>
<div *nzModalFooter>
  <nz-space>
    <button
      *nzSpaceItem
      nz-button
      nzType="default"
      (click)="modal.close()"
    >
      დახურვა
    </button>
    <button
      *nzSpaceItem
      nz-button
      [nzLoading]="isLoading"
      nzDanger
      type="button"
      (click)="deleteBooking()"
    >
      დადასტურება
    </button>
  </nz-space>

</div>
